import { UpSellInclusion, UpSellOption, UpSellInclusionType } from 'models/upsell';

export const getInclusions = (options: UpSellOption[]): UpSellInclusion[] => {
  const allIncs = {}; // all Inclusions aux
  options.map((o) => {
    o.families[0].inclusions.map((inc) => {
      allIncs[inc.code] = inc;
    });
  });
  const arr: UpSellInclusion[] = []; // all Inclusions sorted
  Object.entries(allIncs).map(([key, val]) => {
    arr.push(val as UpSellInclusion);
  });
  return arr.sort((a, b) => (a.rowName < b.rowName ? -1 : a.rowName > b.rowName ? 1 : 0));
};

export const findInclusionByCode = (option: UpSellOption, code: string): UpSellInclusion =>
  option.families[0]?.inclusions.find((item) => item.code === code);

export const getType = (option: UpSellOption, code: string): UpSellInclusionType | string => {
  const data = findInclusionByCode(option, code);
  return data?.type;
};
